import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HttpManagement from '../API/interceptor';

import Header from '../shared/header';
import { RightSidePaneProvider } from '../contexts/rightSidePane/rightSidePane';
import BackButton from '../components/backButton/BackButton';
import { hasActiveSession } from '../utils/session';
import './rootLayout.scss';

export default function RootLayout() {
  const location = useLocation();
  const sessionActive = hasActiveSession();
  const shouldShowHeader = location.pathname !== '/login' && sessionActive;

  const HIDE_BACK = ['/login', '/', '/administrador', '/revisor', '/superadmin', '/logistica'];
  const FULLSCREEN_ADMIN_ROUTES = ['/administrador', '/administrador/menu', '/revisor', '/superadmin', '/logistica'];
  const isReviewerRoute = location.pathname.startsWith('/revisor');
  const reviewerRouteWithBack =
    location.pathname === '/revisor/calendario' ||
    location.pathname.startsWith('/revisor/caracterizaciones');
  const shouldShowBack =
    sessionActive && !HIDE_BACK.includes(location.pathname) && (!isReviewerRoute || reviewerRouteWithBack);
  const shouldUseFullscreenMain =
    FULLSCREEN_ADMIN_ROUTES.includes(location.pathname) || isReviewerRoute;

  return (
    <>
      <HttpManagement>
        <ToastContainer autoClose={5000} hideProgressBar={true} />
        <RightSidePaneProvider>
          <div className='app-shell'>
            {shouldShowHeader ? <Header /> : null}
            <main
              className={`app-main${
                shouldUseFullscreenMain ? ' app-main--fullscreen' : ''
              }`}>
              {shouldShowBack && (
                <div className='app-main__back-slot'>
                  <BackButton fallback='/' />
                </div>
              )}
              <Outlet />
            </main>
          </div>
        </RightSidePaneProvider>
      </HttpManagement>
    </>
  );
}
